/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './product';
import '../../../connect/v2/common/money';
import './inventory_unit';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "resources": {
                "nested": {
                  "LineItem": {
                    "fields": {
                      "productVariant": {
                        "type": "squareup.solidshop.v2.resources.ProductVariant",
                        "id": 1,
                        "rule": "optional"
                      },
                      "unitPrice": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "totalPrice": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "quantity": {
                        "type": "int32",
                        "id": 4,
                        "rule": "optional"
                      },
                      "inventoryUnits": {
                        "type": "squareup.solidshop.v2.resources.InventoryUnit",
                        "id": 5,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.resources?.nested?.LineItem) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE LineItem @ squareup/solidshop/v2/resources/line_item.proto at 12:1
 */
export const LineItem = $root.lookupType('squareup.solidshop.v2.resources.LineItem');
fixType(LineItem);
Builder.createAndAttachToType(LineItem);
